import React, { Component } from "react";
import PropTypes from "prop-types";
import TextField from "../text-field";
import CurrencyInput from "react-currency-input";
import Big from "big.js";
import { If } from "components/support";

class CurrencyField extends Component {
  static propTypes = {
    value: PropTypes.string,
    precision: PropTypes.number,
    separator: PropTypes.string,
    delimiter: PropTypes.string,
    unit: PropTypes.string,
    onChange: PropTypes.func,
    errorText: PropTypes.string
  };

  static defaultProps = {
    value: "0",
    precision: 2,
    separator: ",",
    delimiter: ".",
    unit: "R$",
    suffix: "",
    errorText: "",
    allowNegative: true,
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    this.state = {
      value: "",
      error: false
    };
  }

  componentDidMount() {
    if (this.props.value) {
      this.setValue(this.props.value);
    }
    if (this.props.errorText) {
      this.setError(this.props.errorText !== "");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setValue(nextProps.value);
    }
    if (nextProps.errorText !== this.props.error) {
      this.setError(nextProps.errorText !== "");
    }
  }

  handleOnChange = (event, value) => {
    const decimalValue = new Big(value).toFixed(2).toString();

    if (this.props.disabled) {
      return;
    }
    if (this.props.onChange) {
      this.props.onChange(event, decimalValue);
    }

    this.setValue(decimalValue);
  };

  getLabel() {
    return (
      this.props.label ||
      this.props.floatingLabelText ||
      this.props.hintText ||
      false
    );
  }

  setValue = value => {
    this.setState({ value: value.replace(".", ",") });
  };

  setError = error => {
    this.setState({ error });
  };

  render() {
    const styles = TextField.styles(this.props, this.state);
    return (
      <div className="currency-field" style={styles.field}>
        <div style={{ display: "flex", marginBottom: 4 }}>
          <label>
            <If test={this.getLabel()}>
              <div className="currency-field--label" style={styles.label}>
                {this.getLabel()}
              </div>
            </If>
          </label>
        </div>
        <div className="currency-field--element" style={styles.element}>
          <CurrencyInput
            disabled={this.props.disabled}
            value={this.state.value}
            decimalSeparator=","
            thousandSeparator="."
            prefix={this.props.unit}
            suffix={this.props.suffix}
            style={styles.input}
            allowNegative={this.props.allowNegative}
            onChangeEvent={(event, maskedValue, floatValue) =>
              this.handleOnChange(event, floatValue)
            }
          />
        </div>
        {this.props.errorText.length > 0 && (
          <p className="error-text-message" style={styles.errorText}>
            {this.props.errorText}
          </p>
        )}
      </div>
    );
  }
}

export default CurrencyField;



// WEBPACK FOOTER //
// ./src/components/support/currency-field/index.jsx